import { render, staticRenderFns } from "./Armarios.vue?vue&type=template&id=9879ee52&scoped=true"
import script from "./Armarios.vue?vue&type=script&lang=js"
export * from "./Armarios.vue?vue&type=script&lang=js"
import style0 from "./Armarios.vue?vue&type=style&index=0&id=9879ee52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9879ee52",
  null
  
)

export default component.exports